"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROJECT_AUDIT_LOG = exports.PROJECT_AUDIT_LOGS = void 0;
const route_1 = require("../route");
exports.PROJECT_AUDIT_LOGS = route_1.PROJECT.sub("/auditLogs");
exports.PROJECT_AUDIT_LOG = exports.PROJECT_AUDIT_LOGS.sub("/:auditLogId");
